import map from "lodash/fp/map";

import constants from "../../core/constants";

class CaptainAppVersionsPageTransform {
  constructor() {
    "ngInject";

    this.item = { title: "Captain App Version", state: "captainappversion" };

    this.fields = [
      { title: "Version Name", name: "version_name" },
      { title: "Version Number", name: "version_number" },
      { title: "MD5", name: "md5" },
    ];

    this.addOptions = {
      title: "Add New Version",
      icon: "add",
      fields: [
        {
          title: "Version Number",
          name: "version_number",
          isText: true,
          isRequired: true,
        },
        {
          title: "Version Name",
          name: "version_name",
          isText: true,
          isRequired: true,
        },
        {
          title: "MD5",
          name: "md5",
          isText: true,
          pattern: constants.RegExp.md5,
          patternErrorMsg: "This is not a valid MD5 hash",
          isRequired: true,
        },
        {
          title: "AWS Key",
          name: "aws_key",
          isText: true,
          isRequired: true,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => ({ ...item._source, _id: item._id });

    return map(getSource)(data);
  }
}

export default CaptainAppVersionsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/captainAppVersions/captainAppVersions.transforms.js